/* eslint-disable array-callback-return */
import { TableFooter, TablePagination, TableRow } from '@material-ui/core';
import axios from 'axios';
import moment from 'moment';
import React from 'react';
import { useDispatch } from 'react-redux';
import { setAppStateAction } from '../../../../actions/appStateAction';
import Calender from '../../../../components/Calender';
import { BaseURL } from '../../../../constants';
import { findCap } from '../../utils';

const TableFooterCalendar = ({
  styles,
  state,
  isMobile,
  setStateAction,
  accessLevel,
  rowsPerPage,
  loadUOAData,
}) => {
  const dispatch = useDispatch();
  const setAppState = (payload) => dispatch(setAppStateAction(payload));

  const fetchUOAbyDate = async (date) => {
    const newDate = moment().format('YYYY-MM-DD');
    setAppState({ selectedDate: date });
    if (newDate === date) {
      setAppState({ errorUoa: '' });
      return true;
    } else {
      try {
        const res = await axios.get(`${BaseURL}/api/get-uoa-by-date?date=${date}`);
        if (res.data.length <= 0) {
          setAppState({
            errorUoa: 'We Have no Data related to your search',
          });
          return res.data;
        } else {
          setAppState({ errorUoa: '' });
          return res.data;
        }
      } catch (error) {
        setAppState({
          errorUoa: 'Service Not Available Now',
        });
      }
    }
  };

  const getDateHandler = async (e) => {
    setStateAction({ showLoader: true, date: e });
    localStorage.setItem('Date', e);
    const data = await fetchUOAbyDate(e);
    if (!data || data.length === 0) {
      setStateAction({
        showLoader: false,
        localUOA: [],
      });
      return;
    }

    data.forEach((d) => {
      d['mkt'] = findCap(d['largecap'], d['midcap'], d['smallcap']);
      d['earningObject'] = { date: d.earnings };
      d['earningss'] = d.earnings;
    });

    setStateAction({
      localUOA: data,
      showLoader: false,
    });
  };
  return (
    <TableFooter>
      <TableRow>
        <TablePagination
          style={{ ...styles.pagenation }}
          rowsPerPageOptions={[]}
          count={state.localUOA.length}
          rowsPerPage={rowsPerPage}
          page={state.page - 1}
          onChangePage={(evt, newPage) => {
            setStateAction({ page: newPage + 1 });
          }}
        />
      </TableRow>
      <div
        style={{
          ...styles.bottomdivmobile,
          padding: '0px',
          margin: '-42px 0px 0px 5px',
        }}
      >
        <div
          style={styles.filterbtn}
          role="button"
          onClick={() => setStateAction({ showModal: true })}
        >
          Filter
        </div>

        <Calender
          accessLevel={accessLevel}
          isMobile={isMobile}
          key="UOA"
          getDate={async (e) => getDateHandler(e)}
          value={state.date}
        />
      </div>
    </TableFooter>
  );
};
export default TableFooterCalendar;



// WEBPACK FOOTER //
// ./src/Pages/UnusualOptionsActivity/components/tables/tableFooterCalendar.jsx